<template>
    <div class="answer">

        <!-- 头部 -->
        <div class="answer-header">
            <van-icon name="arrow-left" @click="GoSuperior" color="#333" size="20" />
            <span class="answer-header-span">白癜风银屑病重点公益援助申请表</span>
        </div>

        <!-- 个人信息 -->
        <ul class="answer-userinfor">
            <li class="answer-userinfor-item">
                <div class="answer-userinfor-item-name">姓名</div>
                <input placeholder="请输入你的姓名" v-model="queryparam.uname" class="answer-userinfor-item-input" type="text">
            </li>
            <li class="answer-userinfor-item">
                <div class="answer-userinfor-item-name">联系电话</div>
                <input placeholder="请输入你的电话" v-model="queryparam.telephone" class="answer-userinfor-item-input"
                    type="number">
            </li>
            <li class="answer-userinfor-item">
                <div class="answer-userinfor-item-name">病种</div>
                <van-radio-group class="van-radio-group" v-model="queryparam.disease" direction="horizontal">
                    <van-radio checked-color="#EE0A24" name="白癜风/白斑">白癜风/白斑</van-radio>
                    <van-radio checked-color="#EE0A24" name="银屑病/牛皮癣">银屑病/牛皮癣</van-radio>
                </van-radio-group>
            </li>
            <li class="answer-userinfor-item">
                <div class="answer-userinfor-item-name">选择城市</div>
                <span class="answer-userinfor-item-address" @click="isaddress = true">{{ queryparam.city }}</span>
            </li>
            <li class="answer-userinfor-item">
                <div class="answer-userinfor-item-name">选择时间</div>
                <span class="answer-userinfor-item-address" @click="isdatatime = true">{{ queryparam.regdatetime
                    }}</span>
            </li>
        </ul>

        <!-- 病情时长 -->
        <ul class="answer-userinfor">
            <li class="answer-userinfor-item">
                <div class="answer-userinfor-item-name">是否检查</div>
                <van-radio-group class="van-radio-group" v-model="queryparam.ischeck" direction="horizontal">
                    <van-radio checked-color="#EE0A24" name="1">已确诊</van-radio>
                    <van-radio checked-color="#EE0A24" name="0">未确诊</van-radio>
                </van-radio-group>
            </li>
            <li class="answer-userinfor-item">
                <div class="answer-userinfor-item-name">患者时长</div>
            </li>
            <li class="answer-userinfor-item" style="padding-bottom: 0;">
                <van-radio-group class="van-radio-group-box" v-model="queryparam.duration" direction="horizontal">
                    <van-radio checked-color="#EE0A24" class="van-radio-group-item" name="半年以内">半年以内</van-radio>
                    <van-radio checked-color="#EE0A24" class="van-radio-group-item" name="一年以内">一年以内</van-radio>
                    <van-radio checked-color="#EE0A24" class="van-radio-group-item" name="一至三年">一至三年</van-radio>
                    <van-radio checked-color="#EE0A24" class="van-radio-group-item" name="三年以上">三年以上</van-radio>
                </van-radio-group>
            </li>
        </ul>

        <!-- 个人病史 -->
        <ul class="answer-userinfor">
            <li class="answer-userinfor-item">
                <div class="answer-userinfor-item-name">个人病史</div>
            </li>
            <li class="answer-userinfor-item" style="border-bottom: none;">
                <textarea class="answer-userinfor-textarea" v-model="queryparam.medicalhistory"
                    placeholder="可以大概描述病情，如发病时长、症状、是否治疗" name="" id="">
                </textarea>
            </li>
        </ul>

        <!-- 提交申请 -->
        <div class="Submit-application">

            <div class="submit-btn" @click="SubmitClick">
                提交申请
            </div>

            <div class="xieyi-btn">
                <van-checkbox icon-size="14px" checked-color="#999" v-model="checked"></van-checkbox>
                <span @click="isapplication = true">我已阅读并同意《隐私协议》</span>
            </div>

            <div class="wenxintishi">温馨提示:工作人员将于一个工作日内与你联系请保持手机畅通
            </div>
        </div>

        <!-- 地址弹框 -->
        <van-popup v-model="isaddress" position="bottom" class="van-popup-address">
            <van-area title="标题" @cancel="isaddress = false" @confirm="confirmAddress" :area-list="areaList"
                columns-num="2" />
        </van-popup>

        <!-- 日期弹框 -->
        <van-popup v-model="isdatatime" position="bottom" class="van-popup-address">
            <van-datetime-picker @cancel="isdatatime = false" @confirm="confirmDatetime" type="date" :min-date="minDate"
                :max-date="maxDate" :formatter="formatter" />
        </van-popup>

        <!-- 协议 -->
        <van-popup v-model="isapplication" position="bottom" class="van-popup-address">
            <div class="application-contexnt">

                <div class="application-contexnt-header">
                    <span></span>
                    <span>隐私保护政策</span>
                    <van-icon @click="isapplication = false" name="close" size="24" />
                </div>

                <div class="application-contexnt-text">
                    <p>您的个人信息安全对我们来说至关重要。一直以来，我们都致力于为每位用户提供更安全的互联网环境。我们将依据《中华人民共和国网络安全法》 、 《信息安全技术个人信息安全规范》 (GB/T
                        35273-2020)
                        以及其他相关法律法规和技术规范收集和使用您的个人信息，以帮助我们向您提供更优质的产品和/或服务。我们承诺会对您的个人信息和其它数据进行严格保密，并严格按照本政策所阐述的内容处理您的个人信息。我们会根据您的同意和其它可处理您个人信息的法律依据收集、使用、存储、共享和转移您的个人信息。
                    </p>
                    <p>
                        一、我们收集的个人信息
                        我们遵循合法、正当、必要、最小必要原则，仅收集实现产品功能所必需的信息。
                        （一）注册与账号信息
                        手机号、验证码、昵称、头像、密码（加密存储）
                        用于账号注册、登录、身份验证、账号安全保障
                        （二）使用行为信息
                        浏览、点击、搜索、收藏、分享、停留时长、操作记录
                        用于改善体验、个性化推荐（可关闭）
                    </p>
                </div>

                <div class="application-contexnt-btn">
                    <div @click="isapplication = false">我已知晓</div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { areaList } from "@vant/area-data"
import { Toast, Dialog } from "vant"
import { addSubscribeApi } from "@/api/reservaApi.js"
import { isPhone } from "@/utils/regexp"
export default {
    data() {
        return {
            isaddress: false,
            isdatatime: false,
            isapplication: false,
            checked: false,
            radio: "0",
            diagnosis: "0",
            areaList: areaList,
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2025, 10, 1),
            queryparam: {
                uname: "",
                telephone: "",
                disease: "",
                city: "请选择地区",
                regdatetime: "请选择时间",
                ischeck: -1,
                duration: "",
                medicalhistory: ""
            }
        }
    },
    created() {
        this.formatYMD()
        this.getAfterMonth()
    },
    methods: {
        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`;
            } else if (type === 'day') {
                return `${val}日`;
            }
            return val;
        },
        formatYMD() {
            let date = new Date()
            let y = date.getFullYear();
            let m = (date.getMonth()).toString().padStart(2, '0');
            let d = date.getDate().toString().padStart(2, '0');
            this.minDate = new Date(y, m, d);
        },
        getAfterMonth(monthNum = 3) {
            let date = new Date();
            date.setMonth(date.getMonth() + monthNum);
            let y = date.getFullYear();
            let m = (date.getMonth() + 1).toString().padStart(2, '0');
            let d = date.getDate().toString().padStart(2, '0');
            this.maxDate = new Date(y, m, d);
        },
        confirmAddress(val) {
            this.isaddress = false
            this.queryparam.city = val[0].name == val[1].name ? val[1].name : val[0].name + " / " + val[1].name
        },
        confirmDatetime(val) {
            this.isdatatime = false
            let date = new Date(val)
            let y = date.getFullYear();
            let m = (date.getMonth() + 1).toString().padStart(2, '0');
            let d = date.getDate().toString().padStart(2, '0');
            this.queryparam.regdatetime = `${y}-${m}-${d}`
        },
        GoSuperior() {
            this.$router.go(-1)
        },
        SubmitClick() {
            if (this.checked) {
                if (!this.queryparam.uname) {
                    Toast('请输入你的姓名！');
                    return
                }
                if (!this.queryparam.telephone) {
                    Toast('请输入你的电话！');
                    return
                }
                if (!isPhone(this.queryparam.telephone)) {
                    Toast('请输入合规的手机号码！');
                    return
                }
                if (!this.queryparam.disease) {
                    Toast('请选择你的病种！');
                    return
                }
                if (!this.queryparam.city) {
                    Toast('请选择你的城市！');
                    return
                }
                if (!this.queryparam.regdatetime) {
                    Toast('请选择你的日期！');
                    return
                }
                addSubscribeApi(this.queryparam).then(res => {
                    Dialog.alert({
                        title: '消息提示！',
                        message: res.msg,
                        theme: "round-button"
                    })
                        .then(() => {
                            this.queryparam = {
                                uname: "",
                                telephone: "",
                                disease: "",
                                city: "请选择地区",
                                regdatetime: "请选择时间",
                                ischeck: "",
                                duration: "",
                                medicalhistory: ""
                            }
                        })
                })
            } else {
                Toast('请阅读隐私协议并确定！');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.van-radio-group {
    width: auto;
}

.van-popup-address {
    border-radius: 10px 10px 0 0;
}

::v-deep .van-radio__label {
    font-size: 14px;
    color: #000;
}

.van-radio-group-box {
    display: flex;
    justify-content: space-between;
}

::v-deep .van-radio-group-item {
    width: 100px;
    margin-bottom: 20px;
}

.application-contexnt {
    width: 100%;
    padding: 30px 20px;
    padding-bottom: 10px;
    box-sizing: border-box;

    .application-contexnt-text {
        width: 100%;
        height: 300px;
        margin: 20px 0;
        margin-bottom: 10px;
        overflow: auto;
        font-size: 12px;
        line-height: 20px;
        color: #666;
        letter-spacing: 1px;
    }

    .application-contexnt-btn {
        width: 100%;

        div {
            width: 60%;
            height: 40px;
            border-radius: 20px;
            line-height: 40px;
            font-size: 12px;
            color: #fff;
            text-align: center;
            background-color: #C3171D;
            color: white;
            margin: 0 auto;
        }
    }

    .application-contexnt-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
            color: #000;
            font-size: 14px;
        }

        img {
            width: 20px;
            height: 20px;
        }
    }
}

.answer {
    width: 100%;
    min-height: 100vh;
    background-color: #f5f5f5;
    padding: 20px 5px;
    box-sizing: border-box;

    .Submit-application {
        width: 100%;
        height: auto;
        padding: 30px 0;
        padding-bottom: 0;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;

        .wenxintishi {
            margin-top: 20px;
            color: #000;
            font-size: 12px;
        }

        .xieyi-btn {
            display: flex;
            align-items: center;
            margin-top: 10px;

            span {
                color: #666;
                font-size: 10px;
                margin-left: 5px;
            }
        }

        .submit-btn {
            width: 46%;
            height: 40px;
            background-color: #0c91e9;
            border-radius: 20px;
            line-height: 40px;
            text-align: center;
            color: #fff;
            font-size: 16px;
        }
    }

    .answer-userinfor {
        width: 100%;
        height: auto;
        border-radius: 10px;
        background-color: white;
        padding: 20px;
        box-sizing: border-box;
        margin-top: 10px;
        display: flex;
        flex-direction: column;

        .answer-userinfor-item {
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 20px;
            border-bottom: 0.001rem solid #ccc;
            margin-top: 20px;

            .answer-userinfor-textarea {
                width: 100%;
                min-height: 50px;
                border: none;
                font-size: 14px;
                color: #000;
            }

            .answer-userinfor-textarea::placeholder {
                font-size: 14px;
                color: #666;
            }

            .answer-userinfor-item-name {
                width: auto;
                font-size: 15px;
                color: #000;
                font-weight: bold;
            }

            .answer-userinfor-item-address {
                font-size: 14px;
                color: #666;
            }

            .answer-userinfor-item-input {
                width: 170px;
                font-size: 14px;
                color: #000;
                text-align: right;
            }

            .answer-userinfor-item-input::placeholder {
                font-size: 14px;
                color: #666;
                text-align: right;
            }
        }
    }

    .answer-header {
        width: 100%;
        height: 30px;
        display: flex;
        align-items: center;

        .answer-header-span {
            font-size: 15px;
            color: #000;
            margin-left: 5px;
        }
    }
}
</style>